var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"signout-container"},[_c('Notification',{attrs:{"group":"wrn-signout"}}),_c('LoaderIndicator',{attrs:{"with-container":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }